const en = {
  customer_g2: "BNPP",
  "links.CLI_repository": "https://cli.bnpp.platform.sh",
  "setup.cli.instal.code":
    "curl -sfS https://cli.bnpp.platform.sh/installer | php",
  "setup.cli.instal.label": "Install CLI"
};

export default en;
